import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFaceSmile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1ZM7.5 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm-6.1 4.2a1 1 0 0 1 1.397.196l.005.006.033.041a4.945 4.945 0 0 0 .815.748c.578.42 1.376.81 2.35.81.975 0 1.772-.39 2.35-.81a4.945 4.945 0 0 0 .815-.748l.034-.041.004-.006A1 1 0 0 1 16.8 14.6l-.103.129c-.059.07-.142.164-.248.276a6.951 6.951 0 0 1-.923.804c-.798.58-2 1.191-3.526 1.191-1.525 0-2.728-.61-3.526-1.191a6.949 6.949 0 0 1-1.17-1.08A4.25 4.25 0 0 1 7.2 14.6a1 1 0 0 1 .2-1.4Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgFaceSmile.displayName = 'FaceSmile';
export default SvgFaceSmile;
